import {useCallback, useEffect, useState} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {PaymentIntentResponse, UsePaymentProps} from "../../models/stripe/IStripePayment";
import {BaseErrorTypes} from "../../models/request/IBaseErrorType";
import {StripeApi} from "../Api/stripe/StripeApi";
import { useUi } from "context/ui/UIContext";

export const useStripePayment = (data: UsePaymentProps, enabled: boolean = false) => {
    const {showLoading, hideLoading} = useUi();
    const [result, setResult] = useState<PaymentIntentResponse | null>(null);
    const [error, setError] = useState<BaseErrorTypes | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchPayment = useCallback(async () => {
        setLoading(true);
        showLoading();
        try {
            if (!data.establishmentId || !data.payer?.name) {
                setResult({
                    data: {
                        value: { sessionId: "", clientSecret: "" },
                        status: 0,
                        isSuccess: false,
                        successMessage: "",
                        correlationId: "string",
                    },
                });
            } else {
                const response = await StripeApi().paymentIntent(data);
                setResult(response);
            }
        } catch (err: any) {
            console.log(err)
            setError(err);
        } finally {
            setLoading(false);
            hideLoading();
        }
    }, [data]);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        fetchPayment();
    }, [enabled, fetchPayment]);

    return { data: result, error, loading, refetch: fetchPayment };
};
